import React from "react";

const WhoWeAre = () => {
  return (
    <section id="who-we-are" className="about-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title">Who We Are</h2>
          <div className="title-underline"></div>
        </div>
        <p className="about-description">
          Lume Solutions is a fintech enabler dedicated to helping lenders digitize and scale. 
          We provide intelligent digital lending tools that automate onboarding, credit assessment, 
          and loan management—empowering banks, microfinance institutions, SACCOs, and digital lenders 
          to reach more customers efficiently.
        </p>
        <p className="about-description">
          Our platform bridges the gap between traditional lending and Africa's mobile-first economy, 
          enabling financial institutions to serve the previously unbanked with confidence and precision.
        </p>
      </div>
    </section>
  );
};

export default WhoWeAre;